import { SlotId } from '../../features/google/ad';

import styles from './GoogleAdManagerSlot.module.scss';

import type { FC } from 'react';

type Props = {
  id: SlotId;
};

export const GoogleAdManagerSlot: FC<Props> = ({ id }) => (
  <div className={styles.wrap}>
    <div id={id} />
  </div>
);
